function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1952(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22.8,
    height: 9.54,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.1925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.4,
    y: 4.77
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.54,
    width: 22.8,
    height: 22.34,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.7925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.4,
    y: 20.71
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 31.88,
    width: 22.8,
    height: 29.16,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.5600000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.4,
    y: 46.46
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 61.04,
    width: 22.8,
    height: 31.89,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.5600000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.4,
    y: 76.985
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 92.93,
    width: 22.8,
    height: 37.72,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.533333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.4,
    y: 111.79
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 130.64,
    width: 22.8,
    height: 42.27,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8000000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.4,
    y: 151.77499999999998
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 172.91,
    width: 22.8,
    height: 45.51,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.5600000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.4,
    y: 195.665
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 218.43,
    width: 22.8,
    height: 47.01,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.257142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.4,
    y: 241.935
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 265.43,
    width: 22.8,
    height: 48.6,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8000000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.4,
    y: 289.73
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 314.03,
    width: 22.8,
    height: 48.86,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.257142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.4,
    y: 338.46
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 362.89,
    width: 22.8,
    height: 51.13,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.5600000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.4,
    y: 388.455
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 414.03,
    width: 22.8,
    height: 52.57,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8000000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.4,
    y: 440.315
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 466.59,
    width: 22.8,
    height: 54.55,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.85
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.4,
    y: 493.86499999999995
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 521.15,
    width: 22.8,
    height: 56.77,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.85
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.4,
    y: 549.535
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 577.92,
    width: 22.8,
    height: 60.81,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.85
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.4,
    y: 608.3249999999999
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 638.72,
    width: 22.8,
    height: 61.28,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.85
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.4,
    y: 669.36
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 0,
    width: 34.51,
    height: 41.22,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4509999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.055,
    y: 20.61
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.3,
    y: 0,
    width: 36.49,
    height: 41.22,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.56125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.545,
    y: 20.61
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.79,
    y: 0,
    width: 36.91,
    height: 41.22,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.151666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.245,
    y: 20.61
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.7,
    y: 0,
    width: 37.6,
    height: 41.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.371428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 149.5,
    y: 20.61
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.3,
    y: 0,
    width: 38.53,
    height: 41.22,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.5042857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.565,
    y: 20.61
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.83,
    y: 0,
    width: 39.1,
    height: 41.22,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.585714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 226.38000000000002,
    y: 20.61
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 245.92,
    y: 0,
    width: 39.4,
    height: 41.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 265.62,
    y: 20.61
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 285.33,
    y: 0,
    width: 39.46,
    height: 41.22,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.9325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 305.06,
    y: 20.61
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 324.78,
    y: 0,
    width: 39.67,
    height: 41.22,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.967
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 344.61499999999995,
    y: 20.61
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 364.46,
    y: 0,
    width: 41.72,
    height: 41.22,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.1525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 385.32,
    y: 20.61
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406.18,
    y: 0,
    width: 42.88,
    height: 41.22,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.87
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 427.62,
    y: 20.61
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 449.06,
    y: 0,
    width: 44.12,
    height: 41.22,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.87
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 471.12,
    y: 20.61
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 493.18,
    y: 0,
    width: 47.3,
    height: 41.22,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.244
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 516.83,
    y: 20.61
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 540.48,
    y: 0,
    width: 50.78,
    height: 41.22,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.888571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 565.87,
    y: 20.61
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 591.26,
    y: 0,
    width: 54.26,
    height: 41.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.122
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 618.39,
    y: 20.61
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 645.52,
    y: 0,
    width: 54.48,
    height: 41.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.1525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 672.76,
    y: 20.61
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 41.22,
    width: 57.13,
    height: 43.55,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.959090909090909
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.365,
    y: 62.995
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 84.76,
    width: 57.13,
    height: 44.28,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.38
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.365,
    y: 106.9
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 129.04,
    width: 57.13,
    height: 47.02,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.836666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.365,
    y: 152.54999999999998
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 176.06,
    width: 57.13,
    height: 48.1,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.344444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.365,
    y: 200.11
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 224.16,
    width: 57.13,
    height: 49.43,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.119166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.365,
    y: 248.875
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 273.59,
    width: 57.13,
    height: 49.55,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.19375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.365,
    y: 298.36499999999995
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 323.14,
    width: 57.13,
    height: 51.7,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.4625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.365,
    y: 348.99
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 374.84,
    width: 57.13,
    height: 52.14,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.448571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.365,
    y: 400.90999999999997
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 426.99,
    width: 57.13,
    height: 52.96,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.565714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.365,
    y: 453.47
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 479.95,
    width: 57.13,
    height: 62.66,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.521666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.365,
    y: 511.28
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 542.61,
    width: 57.13,
    height: 78.44,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.14125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.365,
    y: 581.83
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 621.05,
    width: 57.13,
    height: 78.95,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.365,
    y: 660.525
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.93,
    y: 41.22,
    width: 58.33,
    height: 84.79,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.721666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.095,
    y: 83.61500000000001
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.26,
    y: 41.22,
    width: 62.69,
    height: 84.79,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.269
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 169.605,
    y: 83.61500000000001
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 200.95,
    y: 41.22,
    width: 66.23,
    height: 84.79,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.020909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 234.065,
    y: 83.61500000000001
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.18,
    y: 41.22,
    width: 68.59,
    height: 84.79,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.57375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 301.475,
    y: 83.61500000000001
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.77,
    y: 41.22,
    width: 73.54,
    height: 84.79,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.256666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 372.53999999999996,
    y: 83.61500000000001
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 409.31,
    y: 41.22,
    width: 74.17,
    height: 84.79,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.595714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 446.395,
    y: 83.61500000000001
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 483.48,
    y: 41.22,
    width: 92.64,
    height: 84.79,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.131666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 529.8000000000001,
    y: 83.61500000000001
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 576.13,
    y: 41.22,
    width: 123.87,
    height: 84.79,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.131666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 638.065,
    y: 83.61500000000001
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.93,
    y: 126.01,
    width: 115.16,
    height: 92.55,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.221428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.51,
    y: 172.285
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.93,
    y: 218.56,
    width: 115.16,
    height: 109.84,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.73
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.51,
    y: 273.48
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.93,
    y: 328.39,
    width: 115.16,
    height: 161.4,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.19333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.51,
    y: 409.09
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.93,
    y: 489.79,
    width: 115.16,
    height: 210.21,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.469090909090909
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.51,
    y: 594.895
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.09,
    y: 126.01,
    width: 143.81,
    height: 209.4,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.968333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 266.995,
    y: 230.71
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338.9,
    y: 126.01,
    width: 148.13,
    height: 209.4,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 37.0325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 412.965,
    y: 230.71
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 487.03,
    y: 126.01,
    width: 212.97,
    height: 209.4,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 41.88
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 593.515,
    y: 230.71
  }, "\n        Bronx\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.09,
    y: 335.41,
    width: 293.14,
    height: 179.42,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.4275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.65999999999997,
    y: 425.12
  }, "\n        New_York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.09,
    y: 514.83,
    width: 293.14,
    height: 185.17,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 30.861666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.65999999999997,
    y: 607.4150000000001
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 488.23,
    y: 335.41,
    width: 211.77,
    height: 364.59,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 42.354
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 594.115,
    y: 517.705
  }, "\n        Kings\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1952);
export default __webpack_public_path__ + "static/media/1952.005c38a80d9835d2fa536d2caf05e5ca.svg";
export { ForwardRef as ReactComponent };